import {
  ControlledDatePicker
} from '@@viewCommonComponents/controlled';
import { isRequiredInput } from '@@viewHelpers/validations';
import { CustomerProfessionalStatusEnum } from '@fasstech/oip-core/entities/Customer/enums';
import { useWatch } from 'react-hook-form';

const SouscriptionCustomerGranteesExtraCompanyInformation = ({ form }) => {

  const customerProfessionalStatus = useWatch({
    control: form.control,
    name: 'customer.professionalStatus'
  });

  if (customerProfessionalStatus !== CustomerProfessionalStatusEnum.ENTREPRENEUR) {
    return null;
  }

  return (

    <ControlledDatePicker
      name="company.creationDate"
      label="Date de création de l’entreprise"
      data-testid="ADHERENT_COMPANY_CREATION_DATE"
      rules={isRequiredInput(true)}
      form={form}
      disabled={true}
    />

  );
};

export default SouscriptionCustomerGranteesExtraCompanyInformation;
